var inConstruct = 'phrasing';
var notInConstruct = ['autolink', 'link', 'image', 'label'];
exports.unsafe = [{
  character: '@',
  before: '[+\\-.\\w]',
  after: '[\\-.\\w]',
  inConstruct: inConstruct,
  notInConstruct: notInConstruct
}, {
  character: '.',
  before: '[Ww]',
  after: '[\\-.\\w]',
  inConstruct: inConstruct,
  notInConstruct: notInConstruct
}, {
  character: ':',
  before: '[ps]',
  after: '\\/',
  inConstruct: inConstruct,
  notInConstruct: notInConstruct
}];